module.exports = __webpack_public_path__ + "img/banner.223f54e0.png";